import { useCurrentUser } from '../useCurrentUser';

export const useUserPermissionsAndRegion = () => {
  const currentUser = useCurrentUser();

  // For products
  const productRegionId = currentUser.data?.productRegionPreference?.id;
  const productRegionName = currentUser.data?.productRegionPreference?.name;

  // For regional filtration
  const assignedRegions = currentUser.data?.assignedRegions ?? [];
  const assignedRegionIds = assignedRegions.map((r) => r.id);
  const assignedRegionNames = assignedRegions.map((r) => r.name);

  const assignedLocations = currentUser.data?.assignedLocations ?? [];
  const assignedLocationIds = assignedLocations.map((l) => l.id);

  const role = currentUser.data?.role?.value;

  // Roles with full access
  const isAdmin = role === 'Admin';
  const isMedicalDirector = role === 'MedicalDirector';
  const isOperations = role === 'Operations';

  // Roles with region restriction
  const isRegionalUser = role === 'RegionalUser';
  const isTeamLead = role === 'TeamLead';
  const isPhlebotomist = role === 'Phlebotomist';
  const isCanineHandler = role === 'CanineHandler';
  const isDVM = role === 'DVM';

  // Access groups
  const canViewAllRegions = isAdmin || isMedicalDirector || isOperations;
  const hasRegionalRestriction =
    isRegionalUser || isTeamLead || isPhlebotomist || isCanineHandler || isDVM;

  // If there are no assigned locations or regions, the user sees everything (no restrictions)
  const hasLocationRestrictions = assignedLocationIds.length > 0;
  const hasRegionRestrictions = assignedRegionIds.length > 0;

  return {
    // For products
    productRegionId,
    productRegionName,
    // For data filtration
    assignedRegions,
    assignedRegionIds,
    assignedRegionNames,
    assignedLocations,
    assignedLocationIds,
    // Role flags
    isAdmin,
    isMedicalDirector,
    isOperations,
    isRegionalUser,
    isTeamLead,
    isPhlebotomist,
    isCanineHandler,
    isDVM,
    // Access groups
    canViewAllRegions,
    hasRegionalRestriction,
    hasLocationRestrictions,
    hasRegionRestrictions,
    currentUser,
  };
};
